import { ApiObjectHandler } from './abstract-handler';

import * as Types from '../../../types';

export class VHostHandler extends ApiObjectHandler<Types.WebhostingApi.VHost> {}
